import { MuiLinkOverrides } from '../components/link/overrides.js';
import { MuiButtonOverrides } from '../components/mui-button/overrides.js';
import { MuiCheckboxOverrides } from '../components/checkbox/overrides.js';
import { MuiDataGridOverrides } from '../components/data-grid/overrides.js';
import { MuiPaperOverrides } from '../components/mui-paper/overrides.js';
import { MuiMenuOverrides } from '../components/menu-select/overrides.js';
import { MuiSelectOverrides } from '../components/mui-select/overrides.js';
import { MuiSkeletonOverrides } from '../components/skeleton/overrides.js';
import { MuiListItemOverrides } from '../components/list-item/overrides.js';
import { MuiListOverrides } from '../components/list/overrides.js';
import { MuiTextFieldOverrides } from '../components/mui-text-field/overrides.js';
import { MuiInputLabelOverrides } from '../components/mui-input-label/overrides.js';
import { MuiChipOverrides } from '../components/mui-chip/overrides.js';
import { MuiAutocompleteOverrides } from '../components/mui-autocomplete/overrides.js';
import { MuiTypographyOverrides } from '../components/mui-typography/overrides.js';
import { MuiTabsOverrides } from '../components/mui-tabs/overrides.js';
import { MuiSwitchOverrides } from '../components/mui-switch/overrides.js';
import { MuiSvgIconOverrides } from '../components/mui-svg-icon/overrides.js';
import { MuiTooltipOverrides } from '../components/mui-tooltip/overrides.js';
import { MuiAccordionOverrides } from '../components/accordion/overrides.js';
import { MuiButtonGroupOverrides } from '../components/mui-button-group/overrides.js';
import { MuiDatePickerOverrides } from '../components/date-picker/overrides.js';
import { MuiLinearProgressOverrides } from '../components/mui-linear-progress/overrides.js';
import { MuiCircularProgressOverrides } from '../components/mui-circular-progress/overrides.js';
import { MuiContainerOverrides } from '../components/mui-container/overrides.js';
import { MuiAlertOverrides } from '../components/mui-alert/overrides.js';
import { MuiInputAdornmentOverrides } from '../components/mui-input-adornment/overrides.js';
import { MuiAvatarOverrides } from '../components/mui-avatar/overrides.js';
import { MuiDialogOverrides } from '../components/mui-dialog/overrides.js';

const _components = {
  ...MuiTypographyOverrides,
  ...MuiAvatarOverrides,
  ...MuiButtonOverrides,
  ...MuiButtonGroupOverrides,
  ...MuiAccordionOverrides,
  ...MuiLinkOverrides,
  ...MuiCheckboxOverrides,
  ...MuiDataGridOverrides,
  ...MuiPaperOverrides,
  ...MuiMenuOverrides,
  ...MuiSelectOverrides,
  ...MuiSkeletonOverrides,
  ...MuiListItemOverrides,
  ...MuiListOverrides,
  ...MuiTextFieldOverrides,
  ...MuiInputLabelOverrides,
  ...MuiChipOverrides,
  ...MuiAutocompleteOverrides,
  ...MuiInputAdornmentOverrides,
  ...MuiTabsOverrides,
  ...MuiSwitchOverrides,
  ...MuiSvgIconOverrides,
  ...MuiTooltipOverrides,
  ...MuiDatePickerOverrides,
  ...MuiLinearProgressOverrides,
  ...MuiCircularProgressOverrides,
  ...MuiContainerOverrides,
  ...MuiAlertOverrides,
  ...MuiDialogOverrides
};
const components = _components;

export { components };
